export function extractErrorMessage(error: any): string {
    try {
        return (
            error?.response?.data?.errors?.messages?.[0] ||
            error?.response?.data?.message ||
            error?.message ||
            'Falha ao processar a requisição, tente novamente!'
        );
    } catch {
        return 'Falha ao processar a requisição, tente novamente!';
    }
}